import { useForm } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router-dom";
import toast from "react-hot-toast";
import { useResetPassword } from "@/api/auth";
import { getApiErrorMessage } from "@/api/client";

interface FormValues {
  newPassword: string;
  confirmPassword: string;
}

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") ?? "";
  const navigate = useNavigate();
  const resetPassword = useResetPassword();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>();

  const onSubmit = async (values: FormValues) => {
    if (values.newPassword !== values.confirmPassword) {
      toast.error("Las contraseñas no coinciden.");
      return;
    }
    try {
      await resetPassword.mutateAsync({ token, newPassword: values.newPassword });
      toast.success("Contraseña actualizada. Ya puede iniciar sesión.");
      navigate("/login");
    } catch (error) {
      toast.error(getApiErrorMessage(error));
    }
  };

  if (!token) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
        <div className="card max-w-md w-full p-8 text-center">
          <p className="text-sm text-gray-600">Enlace inválido. Solicite un nuevo enlace de recuperación.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="card max-w-md w-full p-8">
        <h1 className="text-xl font-semibold text-gray-900">Restablecer contraseña</h1>

        <form className="mt-6 space-y-4" onSubmit={handleSubmit(onSubmit)} noValidate>
          <div>
            <label className="block text-sm font-medium text-gray-700" htmlFor="newPassword">
              Nueva contraseña
            </label>
            <input
              id="newPassword"
              type="password"
              className="input-field mt-1"
              {...register("newPassword", { required: true, minLength: 10 })}
            />
            {errors.newPassword && <p className="mt-1 text-xs text-red-600">Mínimo 10 caracteres.</p>}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700" htmlFor="confirmPassword">
              Confirmar contraseña
            </label>
            <input
              id="confirmPassword"
              type="password"
              className="input-field mt-1"
              {...register("confirmPassword", { required: true })}
            />
          </div>

          <button type="submit" className="btn-primary w-full" disabled={resetPassword.isPending}>
            {resetPassword.isPending ? "Actualizando..." : "Actualizar contraseña"}
          </button>
        </form>
      </div>
    </div>
  );
}
